import React from "react";
import Frame92 from "../subcomponents/Frame92";
import Frame88 from "../subcomponents/Frame88";

const Frame87 = () => {
      return(
            <div className="vector-parent7">
                  <img className="frame-item" alt="" src="/polygon-2.svg" />
                  <Frame88 />
                  <Frame92 />
            </div>
      );
};

export default Frame87;